<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12 w-100">
            <h3 class="title">
                <span *ngIf="neworganisation" translate="Settings.OrganisationEditSection.AddOrganisation"></span>
                <span *ngIf="!neworganisation" translate="Settings.OrganisationEditSection.EditOrganisation"></span>
            </h3>
        </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="save()">
        <div class="p-4 pt-1">
            <div class="mb-3 col-12" *ngIf="!neworganisation">
                <label for="WhitelabelParent" class="form-label"
                    translate="Settings.OrganisationEditSection.WhitelabelParent"></label>
                <div ngbDropdown class="dropdown" ngDefaultControl id="WhitelabelParent">
                    <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle [disabled]="user === undefined || !user.isSystemAdmin">
                        <span>{{selectedWhitelabelProviderName}}</span><em class="bi bi-chevron-down float-end ms-2"
                            aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                        <button ngbDropdownItem type="button"
                            *ngFor="let whitelabelProviderOption of whitelabelProviders"
                            (click)="selectWhiteLabelProvider(whitelabelProviderOption)">
                            <span>{{whitelabelProviderOption.name}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mb-3 col-12">
                <label for="OrganisationName" class="form-label"
                    translate="Settings.OrganisationEditSection.OrganisationName"></label>
                <input type="text" id="OrganisationName" class="form-control" formControlName="organisationName">
                <app-formcontrol-error-messages [forControl]="organisationNameControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-12">
                <label for="SubscriptionPlan" class="form-label"
                    translate="Settings.OrganisationEditSection.SubscriptionPlan"></label>
                <div ngbDropdown class="dropdown" ngDefaultControl id="SubscriptionPlan">
                    <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle>
                        <span>{{'Settings.OrganisationEditSection.' + subscriptionLevel | translate }}</span><em
                            class="bi bi-chevron-down float-end ms-2" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                        <button ngbDropdownItem type="button"
                            (click)="updateOrganisationValue('subscriptionLevel', 'Basic')"><span
                                translate="Settings.OrganisationEditSection.Basic"></span></button>
                        <button ngbDropdownItem type="button"
                            (click)="updateOrganisationValue('subscriptionLevel', 'Standaard')"><span
                                translate="Settings.OrganisationEditSection.Standaard"></span></button>
                        <button ngbDropdownItem type="button"
                            (click)="updateOrganisationValue('subscriptionLevel', 'Plus')"><span
                                translate="Settings.OrganisationEditSection.Plus"></span></button>
                    </div>
                </div>
            </div>
            <div class="mb-3 col-12">
                <label for="accountLicenses" class="form-label"
                    translate="Settings.OrganisationEditSection.AccountLicenses"></label>
                <input type="text" id="accountLicenses" class="form-control" formControlName="accountLicenses">
                <app-formcontrol-error-messages [forControl]="accountLicensesControl"></app-formcontrol-error-messages>
            </div>
            <div class="mt-2 mb-1 d-table col-12">
                <span class="pt-5 pb-2 col-12" translate="Settings.OrganisationEditSection.Options"></span>
                <ul class="mb-3 mt-2 list-group">
                    <li class="list-group-item d-block">
                        <div class="row row-cols-12 d-flex align-items-center">
                            <div class="d-table form-check form-switch">
                                <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                    role="switch" id="enablePrivateBlob" name="enablePrivateBlob"
                                    (click)="updateSwitch('enablePrivateBlob', $event)"
                                    [(ngModel)]="customStorageEnabled" [checked]="customStorageEnabled">
                                <label translate="Settings.OrganisationEditSection.EnablePrivateBlob"
                                    for="enablePrivateBlob"></label>
                            </div>
                        </div>
                    </li>
                    <li class="list-group-item d-block">
                        <div class="row row-cols-12 d-flex align-items-center">
                            <div class="d-table form-check form-switch">
                                <input class="float-none switch-form-default form-check-input items" type="checkbox"
                                    role="switch" id="enableBranding" name="enableBranding"
                                    (click)="updateSwitch('enableBranding', $event)" [(ngModel)]="whitelabelEnabled"
                                    [checked]="whitelabelEnabled">
                                <label translate="Settings.OrganisationEditSection.EnableBranding"
                                    for="enableBranding"></label>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-12 mt-4 pb-2 d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()"
                        translate="Button.Back"></button></span>
                <span class="float-end"><button type="submit" [disabled]="!form.valid" class="btn btn-sm btn-primary"
                        translate="Button.Save"></button></span>
            </div>
        </div>
    </form>
</div>